import { Loading } from "@/components/common/Loading";
import { ReminderTypeService } from "@/service/services/ReminderTypee.service";
import { RleStructureService } from "@/service/services/RleStructure.service";
import { TimeZoneService } from "@/service/services/TimeZone.service";
import { Typography } from "@mui/material";
import { useState } from "react";
import { Modal } from "../Modal";
import { ModalBody } from "../ModalBody";
import { ModalFooter } from "../ModalFooter";
import { ModalHeader } from "../ModalHeader";
import { Props } from "./ModalStructureManteinerDelete.type";

export const ModalStructureManteinerDelete: React.FC<Props> = (props:any): JSX.Element => {
    const { open, closeModal, actionSelected, structure, onListStructure, clearState } = props;
    const [loading, setLoading] = useState<boolean>(false);

    const onDeleted= async()=>{
        setLoading(true);
        await RleStructureService.deleteRLEStructure(structure.id).then((data) => {
            onListStructure && onListStructure();
            closeModal && closeModal();
        })
        setLoading(false);
    }
  
  return (
    <>
    {loading && <Loading/>}
    <Modal
      open={open}
      handleClose={closeModal}
      size="xs"
    >
      <ModalHeader
        text="ELIMINAR ESTRUCTURA"
        className='positionElements'
        onCancel={closeModal}
        clearState={clearState}
      >
      </ModalHeader>

      <ModalBody>
        <Typography variant="subtitle1" className="textColor"> 
          ¿Está seguro de eliminar esta Estructura?
        </Typography>
      </ModalBody>

      <ModalFooter 
        confirmText="Eliminar"
        cancelText="CANCELAR"
        onCancel={closeModal}
        className="footerRight"
        onConfirm={onDeleted}
        clearState={clearState}
      />
    </Modal>
    </>
  )
}